<div class="subpunt__row" *ngFor="let subpunt of detail.Subpunten">
    <div class="subpuntrow__titelcol">
        {{subpunt.Volgnummer}} {{subpunt.Titel}}
    </div>
    <div class="subpuntrow__standpuntcol" *ngIf="subpunt.StandpuntToegelaten">

        <span role="text" attr.aria-label="Algemeen standpunt: aantal aanvaard : {{subpunt.StandpuntAanvaard}}, aantal bespreken : {{subpunt.StandpuntBespreken}}, aantal onbepaald : {{subpunt.StandpuntOnbepaald}}" class="algemeenstandpunt">Algemeen standpunt</span>
        
        <!-- <span class="screen-reader-only">
            Algemeen standpunt: aantal aanvaard : {{subpunt.StandpuntAanvaard}}, aantal bespreken : {{subpunt.StandpuntBespreken}}, aantal onbepaald : {{subpunt.StandpuntOnbepaald}}
        </span> -->
        
        <span aria-hidden="true" class="green-txt-light">{{subpunt.StandpuntAanvaard}}
            <i class="icon-agree standpunticon"></i>
        </span>
        <span aria-hidden="true" class="red-txt">{{subpunt.StandpuntBespreken}}
            <i class="icon-disagree standpunticon"></i>
        </span>
        <span aria-hidden="true">{{subpunt.StandpuntOnbepaald}}
            <i class="icon-udecided standpunticon"></i>
        </span>
    </div>
</div>

<div role="list" class="document-list" *ngIf="detail.Documenten.length">
    <a href="#" role="listitem"  *ngFor="let document of detail.Documenten;trackBy:getDocumentId"
     (click)="showDocument(document)">
        <i aria-hidden="true" class="icon-file document-icon"></i>{{document.Titel}}
    </a>
</div>

<div *ngIf="detail.StandpuntToegelaten">

    <span role="img" attr.aria-label="Algemeen standpunt: aantal aanvaard : {{detail.StandpuntAanvaard}}, aantal bespreken : {{detail.StandpuntBespreken}}, aantal onbepaald : {{detail.StandpuntOnbepaald}}" class="algemeenstandpunt">Algemeen standpunt</span>
    <!-- <span class="screen-reader-only">
        Algemeen standpunt: aantal aanvaard : {{detail.StandpuntAanvaard}}, aantal bespreken : {{detail.StandpuntBespreken}}, aantal onbepaald : {{detail.StandpuntOnbepaald}}
    </span> -->
    <span aria-hidden="true" class="green-txt-light">{{detail.StandpuntAanvaard}}
        <i class="icon-agree standpunticon"></i>
    </span>
    <span aria-hidden="true" class="red-txt">{{detail.StandpuntBespreken}}
        <i class="icon-disagree standpunticon"></i>
    </span>
    <span aria-hidden="true">{{detail.StandpuntOnbepaald}}
        <i class="icon-udecided standpunticon"></i>
    </span> 
    
</div>

